<template>
    <page>
        <div class="shadow-1 self-stretch full-width full-height" ref="container" v-if="form">
            <q-tabs align="justify">
                <q-tab
                    default
                    slot="title"
                    name="lending-point"
                    :label="$T('lending point')"
                />
                <q-tab
                    slot="title"
                    name="reverse-flow"
                    :label="$T('products')"
                />

                <q-tab-pane name="lending-point">
                    <auto-form
                        class="bg-white"
                        baseRoute="backoffice.lending-point"
                        slug="lending-point"
                        :enable-submit-button="false"
                        :display-header="false">
                    </auto-form>
                </q-tab-pane>

                <q-tab-pane name="reverse-flow">
                    <div class="shadow-25">
                        <v-header :title="$T('products')" icon="list">
                            <template slot="right">
                                <v-button
                                    flat
                                    rounded
                                    dense
                                    color="primary"
                                    icon="list"
                                    :label="$T('go to list')"
                                    @click="
                    $router.push({
                      name: `backoffice.lending-point.index`,
                    })
                  "
                                />

                                <v-button
                                    flat
                                    rounded
                                    dense
                                    color="primary"
                                    icon="add"
                                    :label="$T('add new')"
                                    @click="
                    $router.push({
                      name: `backoffice.lending-point.reverse-flow`,
                    })
                  "
                                />
                            </template>
                        </v-header>

                        <q-table
                            class="bg-white full-width ag-theme-material"
                            :filter="filter"
                            :pagination.sync="serverPagination"
                            :data="rowData"
                            :columns="columns"
                            :rows-per-page-options="[10, 20, 50, 100]"
                            row-key="description"
                        >
                            <q-td
                                slot="body-cell--actions"
                                slot-scope="cell"
                                class="text-right"
                                style="width: 100px"
                            >

                            <v-button
                                    color="info"
                                    class="on-right"
                                    icon="info"
                                    @click.prevent="auditoriaRow(cell.row.id)"
                                    size="sm"
                                    round
                                    dense
                                />
                                <v-button
                                    color="info"
                                    class="on-right"
                                    icon="edit"
                                    @click.prevent="editRow(cell.row.id)"
                                    size="sm"
                                    round
                                    dense
                                />

                                <v-button
                                    color="negative"
                                    class="on-right"
                                    icon="delete"
                                    size="sm"
                                    round
                                    dense
                                >
                                    <q-popover>
                                        <div class="group text-center">
                                            <p>
                                                <strong>{{ $T("are you sure?") }}</strong>
                                            </p>
                                            <v-button
                                                class="no-shadow capitalize"
                                                color="negative"
                                                no-caps
                                                icon="delete"
                                                @click="deleteRow(cell.row.id)"
                                                v-close-overlay
                                            >
                                                {{ $t("delete") }}
                                            </v-button>
                                            <v-button
                                                class="no-shadow capitalize"
                                                color="faded"
                                                no-caps
                                                v-close-overlay
                                            >
                                                {{ $t("cancel") }}
                                            </v-button>
                                        </div>
                                    </q-popover>
                                </v-button>
                            </q-td>
                        </q-table>
                    </div>
                </q-tab-pane>
            </q-tabs>
        </div>
        <div class="justify-center row layout-padding" v-else>
            <spinner-iqos size="60px"/>
        </div>
        <q-modal v-model="isModalVisible" :data="modalData">
            <div>
                <div class="col q-title text-center q-pa-lg">{{ $T("audits") }}</div>
                <table border="1" class="q-table q-table-horizontal-separator">
                <tr>
                    <td>{{ $T("created at") }}</td>
                    <td>{{ modalData.created_at }}</td>
                </tr>
                <tr>
                    <td>{{ $T("created by") }}</td>
                    <td>{{ modalData.user_id_created }}</td>
                </tr>
                <tr>
                    <td>{{ $T("updated at") }}</td>
                    <td>{{ modalData.updated_at }}</td>
                </tr>
                <tr>
                    <td>{{ $T("updated by") }}</td>
                    <td>{{ modalData.user_id_updated }}</td>
                </tr>
                </table>
            </div>
        </q-modal>
    </page>
</template>

<style>
.q-tab-pane {
    padding: 0px;
}

.q-tab-pane > main.q-layout-page {
    padding-top: 0px;
}
</style>

<script>
import {
    QTabs,
    QTab,
    QTabPane,
    QTable,
    QPopover,
    openURL,
    QDialog
} from "quasar-framework";
import AutoForm from "../../../../../components/AutoForm.vue";
import axios from "axios";
import {mapGetters} from "vuex";
import {AgGridVue} from "ag-grid-vue";
import VDisplay from "../../../../../components/form/VDisplay";
import Card from "../../../../../components/Card";

export default {
    middleware: "auth",
    data() {
        return {
            filter: "",
            columns: [
                {
                    label: this.$T("Product"),
                    field: "description",
                    name: "description",
                },
                {
                    label: this.$T("Minimum Stock"),
                    field: "minimum_stock",
                    name: "minimum_stock",
                },
                {
                    label: this.$T("Maximum Stock"),
                    field: "maximum_stock",
                    name: "maximum_stock",
                },
                {label: this.$T("actions"), field: "-actions", name: "-actions"},
            ],
            serverPagination: {
                page: 1,
                rowsNumber: 10,
            },
            rowData: [],
            form: null,
            fullData: [],
            isModalVisible: false,
            modalData: []
        };
    },
    methods: {
        async getReverseFlowData({pagination, filter}) {
            await axios
                .get("/api/v1/lending-point/" + this.$route.params.id + "/reverse-flow")
                .then((res) => {
                    let columns = res.data.data;

                    this.serverPagination.rowsNumber = res.data.total;
                    columns = Object.keys(columns).map((key) => columns[key]);

                    this.fullData = res.data.data;

                    this.rowData = columns.map((column) => ({
                        description: column.description,
                        minimum_stock: column.minimum_stock,
                        maximum_stock: column.maximum_stock,
                        id: column.product_model_id,
                    }));
                });
        },

        importFile(id) {
            this.$router.push({
                name: `backoffice.lending-point.reverse-flow.import`,
                params: {id},
            });
        },

        exportFile(id) {
            openURL(`${window.config.appUrl}/lending-point/` + id + `/export/`);

            // this.$router.push({
            //   name: `backoffice.lending-point.reverse-flow.export`,
            //   params: { id },
            // });
        },

        editRow(id) {
            this.$router.push({
                name: `backoffice.lending-point.reverse-flow`,
                params: {
                    id: this.$route.params.id,
                    product: id,
                },
            });
        },

        deleteRow(id) {
            axios
                .delete(
                    "/api/v1/lending-point/" + this.$route.params.id + "/detach/" + id
                )
                .then((data) => {
                    this.$q
                        .dialog({
                            title: this.$T("success"),
                            message: data.data.success.message,
                            preventClose: true,
                            color: "primary",
                            stackButtons: true,
                            ok: {
                                label: this.$T("close"),
                            },
                        })
                        .then(() => {
                            this.getReverseFlowData({
                                pagination: this.serverPagination,
                                filter: this.filter,
                            });
                        });
                });
        },

        auditoriaRow(id) {
            const item = this.fullData.find(item => item.product_model_id === id);
            if (item) {
                this.modalData = item;
                this.isModalVisible = true;
            }
            
        },

        async getLendingPointInformation() {
            await axios.get(`${config.appUrl}/api/lending-point/${this.$route.params.id}?transform=false`)
                .then(({data}) => {
                    this.form = data.model
                });
        }
    },
    mounted() {
        this.getReverseFlowData({
            pagination: this.serverPagination,
            filter: this.filter,
        });

        this.getLendingPointInformation()
    },
    computed: {
        ...mapGetters({
            user: "auth/user",
        }),
    },

    components: {
        Card,
        VDisplay,
        QTabs,
        QTab,
        QTabPane,
        AutoForm,
        AgGridVue,
        QTable,
        QPopover,
        QDialog
    },
};
</script>


// WEBPACK FOOTER //
// resources/assets/js/markets/ES/pages/backoffice/lending-point/detail.vue